module.exports = __webpack_public_path__ + "img/warranty.1e3619b3.png";